import React from 'react';

/**
 * OIM Status Indicator (§7.4)
 *
 * PROVISIONAL -> yellow
 * FINAL       -> green
 * MIXED       -> amber/blue (some hours final, some still provisional)
 * EMPTY       -> gray (no data)
 */
const STATUS_STYLES = {
  PROVISIONAL: {
    dot: 'bg-yellow-500',
    bg:  'bg-yellow-50',
    text: 'text-yellow-800',
    border: 'border-yellow-200',
    label: 'Provisional',
  },
  FINAL: {
    dot: 'bg-green-500',
    bg:  'bg-green-50',
    text: 'text-green-800',
    border: 'border-green-200',
    label: 'Final',
  },
  MIXED: {
    dot: 'bg-blue-500',
    bg:  'bg-blue-50',
    text: 'text-blue-800',
    border: 'border-blue-200',
    label: 'Mixed',
  },
  EMPTY: {
    dot: 'bg-gray-400',
    bg:  'bg-gray-50',
    text: 'text-gray-700',
    border: 'border-gray-200',
    label: 'No Data',
  },
};

const StatusIndicator = ({ status, small = false }) => {
  const cfg = STATUS_STYLES[status] || STATUS_STYLES.EMPTY;
  const sizing = small
    ? 'px-2 py-0.5 text-xs'
    : 'px-3 py-1 text-sm';

  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border ${cfg.bg} ${cfg.text} ${cfg.border} ${sizing} font-medium`}
      title={`OIM data status: ${cfg.label}`}
    >
      <span className={`inline-block w-2 h-2 rounded-full ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
};

export default StatusIndicator;
